module.exports = __webpack_public_path__ + "img/jhbLog.c5876bda.png";